import React, { Component } from 'react';
import {Switch, Route, Link, Redirect} from 'react-router-dom';
import {Grid, Row, Col, Panel} from 'react-bootstrap';
import AccountsCreatedChart from './metrics/AccountsCreatedChart';
import JobPostsCreatedChart from './metrics/JobPostsCreatedChart';
import JobApplicationCountChart from './metrics/JobApplicationCountChart';
import CumulativeUserCountChart from './metrics/CumulativeUserCountChart';

export class Dashboard extends Component {
  render() {
    return (
      <Grid style={{padding: 20}} fluid>
        <Row>
          <Col xs={12}>
            <h1>Platform Analytics</h1>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <Panel style={{margin: 'auto'}}>
              <AccountsCreatedChart />
            </Panel>
          </Col>
          <Col xs={3}>
            <Panel style={{margin: 'auto'}}>
              <JobPostsCreatedChart />
            </Panel>
          </Col>
          <Col xs={3}>
            <Panel style={{margin: 'auto'}}>
              <JobApplicationCountChart />
            </Panel>
          </Col>
          <Col xs={3}>
            <Panel style={{margin: 'auto'}}>
              <CumulativeUserCountChart />
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}
